import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import { kebabCase } from 'lodash';
import React from 'react';
import { Icon } from '../../Icon';
import { SelectList } from '../Select.List';
import { SelectContextWrapper } from '../SelectContextWrapper';
import { useSelectContext } from '../useSelectContext';
import styles from './Select.Option.scss';

function isEqual(a, b) {
  return a && b && a.equals ? a.equals(b) : a === b;
}

var SelectOptionTriggerButton = function SelectOptionTriggerButton(props) {
  var _classnames;

  var _useSelectContext = useSelectContext(),
      isOpen = _useSelectContext.isOpen,
      popper = _useSelectContext.popper,
      buttonRef = _useSelectContext.buttonRef,
      onOpen = _useSelectContext.onOpen,
      onClose = _useSelectContext.onClose,
      hasParentMenu = _useSelectContext.hasParentMenu;

  var optionClasses = classnames(styles.option, (_classnames = {}, _defineProperty(_classnames, styles.optionSelected, props.selected), _defineProperty(_classnames, styles.optionDisabled, props.disabled), _defineProperty(_classnames, styles.descriptionPresent, props.description), _defineProperty(_classnames, styles.highlighted, isOpen), _classnames));

  var openAndFocusMenu = function openAndFocusMenu() {
    onOpen();

    if (popper.ref.current) {
      popper.ref.current.focus();
    }
  };

  var handleMouseEnter = function handleMouseEnter() {
    if (!hasParentMenu) return;
    onOpen();
  };

  var handleMouseLeave = function handleMouseLeave() {
    onClose();
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      openAndFocusMenu();
    } else if (event.key === 'ArrowDown') {
      if (!hasParentMenu) {
        onOpen();
      }
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();

      if (hasParentMenu) {
        onOpen();
      }
    }
  };

  return React.createElement("button", {
    role: "option",
    "aria-label": "".concat(props.label, ", Option Group, arrow right to open"),
    "aria-selected": props.selected ? 'true' : 'false',
    ref: buttonRef,
    className: classnames(styles.selectOptionButton, _defineProperty({}, styles.disabled, props.disabled)),
    "data-test": props.dataTest,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onKeyDown: handleKeyDown
  }, React.createElement("div", {
    className: classnames(optionClasses, styles["indentation".concat(props.indentLevel)]),
    "data-test": "select-option-text-".concat(kebabCase(props.label))
  }, props.prefixIcon && React.createElement("div", {
    className: styles.iconWrapper
  }, props.prefixIcon), React.createElement("div", {
    className: classnames(styles.primary, styles.primaryChild),
    "data-test": "select-option-primary-text-".concat(kebabCase(props.label))
  }, props.label), props.secondaryLabel ? React.createElement("div", {
    className: classnames(styles.secondary, _defineProperty({}, styles.optionDisabled, props.disabled)),
    "data-test": "select-option-secondary-text-".concat(kebabCase(props.secondaryLabel))
  }, props.secondaryLabel) : null, React.createElement(Icon, {
    icon: "arrow-caret-down",
    className: styles.caret
  })));
};

var SelectOptionButton = function SelectOptionButton(props) {
  var _classnames4;

  var _useSelectContext2 = useSelectContext(),
      selectedValue = _useSelectContext2.selectedValue,
      onChange = _useSelectContext2.onChange,
      onCloseAll = _useSelectContext2.onCloseAll;

  var isSelected = props.value && isEqual(selectedValue, props.value);
  var optionClasses = classnames(styles.option, (_classnames4 = {}, _defineProperty(_classnames4, styles.optionSelected, isSelected), _defineProperty(_classnames4, styles.optionDisabled, props.disabled), _defineProperty(_classnames4, styles.descriptionPresent, props.description), _classnames4));

  var handleClick = function handleClick(event) {
    event.preventDefault();
    onChange(props.value);
    onCloseAll();
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(props.value);
      onCloseAll();
    }
  };

  return React.createElement("button", {
    role: "option",
    "aria-selected": isSelected ? 'true' : 'false',
    className: classnames(styles.selectOptionButton, _defineProperty({}, styles.disabled, props.disabled)),
    "data-test": props.dataTest,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, React.createElement("div", {
    className: classnames(optionClasses, styles["indentation".concat(props.indentLevel)]),
    "data-test": "select-option-text-".concat(kebabCase(props.label))
  }, props.prefixIcon && React.createElement("div", {
    className: styles.iconWrapper
  }, props.prefixIcon), React.createElement("div", {
    className: styles.labelsContainer
  }, React.createElement("div", {
    className: styles.flexContainer
  }, React.createElement("div", {
    className: styles.primary,
    "data-test": "select-option-primary-text-".concat(kebabCase(props.label))
  }, props.label), props.secondaryLabel ? React.createElement("div", {
    className: classnames(styles.secondary, _defineProperty({}, styles.optionDisabled, props.disabled)),
    "data-test": "select-option-secondary-text-".concat(kebabCase(props.secondaryLabel))
  }, props.secondaryLabel) : null), props.description ? React.createElement("div", {
    className: styles.description,
    "data-test": "select-option-description-text-".concat(kebabCase(props.description))
  }, props.description) : null)));
};

export var SelectOption = function SelectOption(props) {
  var _useSelectContext3 = useSelectContext(),
      onChange = _useSelectContext3.onChange,
      selectedValue = _useSelectContext3.selectedValue;

  var hasSelection = false;
  React.Children.toArray(props.children).forEach(function (child) {
    if (isEqual(child.props.value, selectedValue)) {
      hasSelection = true;
    }
  });
  return props.children ? React.createElement(SelectContextWrapper, {
    onChange: onChange,
    selectedValue: selectedValue
  }, React.createElement(SelectOptionTriggerButton, Object.assign({}, props, {
    selected: hasSelection
  })), React.createElement(SelectList, null, props.children)) : React.createElement(SelectOptionButton, Object.assign({}, props));
};
SelectOption.displayName = 'Select.Option';